import React, { useState, useEffect } from 'react';
import {
    DndContext,
    closestCenter,
    useSensor,
    useSensors,
    PointerSensor,
    KeyboardSensor,
} from '@dnd-kit/core';
import {
    arrayMove,
    SortableContext,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import {
    sortableKeyboardCoordinates,
    useSortable,
} from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useSnackbar } from 'notistack';
import {
    List,
    ListItem,
    ListItemText,
    ListItemIcon,
    LinearProgress,
    Typography,
} from '@mui/material';
import DragIndicatorRoundedIcon from '@mui/icons-material/DragIndicatorRounded';
import axios from 'axios';
import { connect } from 'trim-redux';
import { defaultVariables } from '../../../../../config';
import AppCardLoaderFields from '../../../../components/loaders/AppCardLoaderFields';
import Grid from '@mui/material/Grid2';
import {useTranslation} from "react-i18next";

const SortableItem = ({ id, name }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
        useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    return (
        <ListItem className="draggable-com" ref={setNodeRef} style={style} {...attributes} {...listeners}>
            <ListItemIcon style={{ padding: '8px' }}>
                <DragIndicatorRoundedIcon color="secondary" fontSize="large" />
            </ListItemIcon>
            <ListItemText
                primary={<Typography>{name}</Typography>}
            />
        </ListItem>
    );
};

const CategoriesOrder = ({ parent: initialParent, reload, industry_id }) => {
    const [variables, setVariables] = useState([]);
    const [loading, setLoading] = useState(true);
    const [dragLoading, setDragLoading] = useState(false);
    const [parent, setParent] = useState(initialParent);
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation();


    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    useEffect(() => {
        loadData();
    }, [parent]);

    const loadData = async () => {
        setLoading(true);
        const loginToken = localStorage.getItem('ACT');
        if (!loginToken) return;

        try {
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`,
                },
            };
            const response = await axios.get(
                `${defaultVariables.url}/categories/get-all-parents${!!industry_id ? "?industry="+industry_id : '' }`,
                config
            );
            setVariables(response.data);
        } catch (error) {
            console.error(error.response);
            enqueueSnackbar(t('errorLoadingData'), { variant: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const handleDragEnd =  async ({ active, over }) => {
        if (!over || active.id === over.id) return;

        const oldIndex = variables.findIndex((item) => item.id === active.id);
        const newIndex = variables.findIndex((item) => item.id === over.id);

        setDragLoading(true);
        setVariables((prev) => arrayMove(prev, oldIndex, newIndex));

        const data = new FormData();
        data.append('source', active.id);
        data.append('destination', over.id);
        try {
            const loginToken = localStorage.getItem('ACT');
            const config = {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Bearer ${loginToken}`,
                },
            };
            await axios.post(
                `${defaultVariables.url}/categories/changeOrder`,
                data,
                config
            );
        } catch (error) {
            console.error(error.response);
        } finally {
            setDragLoading(false);

        }
    };

    return (
        <>
            {loading ? (
                <AppCardLoaderFields />
            ) : (
                <Grid container spacing={2} justifyContent="center" alignItems="center" className="drag-con">
                    <Grid item size={12}>
                        {dragLoading && <LinearProgress />}
                    </Grid>
                    <Grid item size={12}>
                        {variables.length > 0 ? (
                            <DndContext
                                sensors={sensors}
                                collisionDetection={closestCenter}
                                onDragEnd={handleDragEnd}
                            >
                                <SortableContext
                                    items={variables.map((item) => item.id)}
                                    strategy={verticalListSortingStrategy}
                                >
                                    <List>
                                        {variables.map((item) => (
                                            <SortableItem
                                                key={item.id}
                                                id={item.id}
                                                name={item.name}
                                            />
                                        ))}
                                    </List>
                                </SortableContext>
                            </DndContext>
                        ) : (
                            <Typography>{t('noItemsFound')}</Typography>
                        )}
                    </Grid>
                </Grid>
            )}
        </>
    );
};

const mapStateToProps = (state) => ({
    locale: state.locale,
});

export default connect(mapStateToProps)(CategoriesOrder);
